<template>
  <article class="article__metadata">
    <!-- AUTHORS LIST -->
    <template v-for="(autor, index) in authors" :key="index">
      <span class="article__author">{{ autor }}</span
      >{{ authors.length - 1 != index ? "; " : "" }}{{ " " }}
    </template>

    <!-- ISSUED DATE -->
    <template v-if="dateIssued">
      <span class="article__issued">({{ dateIssued }})</span>.{{ " " }}
    </template>

    <!-- TITLE -->
    <template v-if="title">
      <a
        class="article__title"
        :href="sourcePath"
        target="_blank"
        :title="title"
      >
        <i>{{ title }}</i> </a
      >.{{ " " }}
    </template>

    <!-- LEVEL OF THESIS -->
    <template v-if="degree">
      [<span class="article__degree"> {{ degree }} </span>,
      <span class="article__grantor"> {{ grantor }} </span>].
    </template>

    <!-- DOI -->
    <template v-if="doi">
      <a class="article__doi" :href="doi" target="_blank">
        {{ doi }}
      </a>
    </template>
    <template v-else>
      <a class="article__doi" :href="sourcePath" target="_blank">
        {{ sourcePath }}
      </a>
    </template>
  </article>
</template>
<script>
export default {
  components: {},
  props: {
    sourcePath: {
      type: String
    },
    title: {
      type: String,
      default: "No title"
    },
    authors: {
      type: Array,
      default: () => []
    },
    dateIssued: {
      type: String
    },
    degree: {
      type: String
    },
    grantor: {
      type: String
    },
    doi: {
      type: String
    }
  }
};
</script>
